import type {RecruitmentDetailSchedule} from '../../../../../core/entities/recruitment/schema';
import {formatScheduleDataByRecruitDetail} from '../../../../../core/factories/recruitment/formatScheduleData';
import {Schedule} from './Schedule';

export const ScheduleList: React.FC<{
  schedules: RecruitmentDetailSchedule[];
}> = ({schedules}) => {
  return (
    <ul className="bg-background-1 p-12">
      {schedules.map((schedule) => {
        const formatedSchedule = formatScheduleDataByRecruitDetail(schedule);

        return <Schedule schedule={formatedSchedule} />;
      })}
    </ul>
  );
};
